import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import ApprovalGroupsTable from './components/ApprovalGroupsTable';
import ApprovalGroupsForm from './components/ApprovalGroupsForm';
import ApprovalGroupsFilter from './components/ApprovalGroupsFilter';
import ApprovalHistoryDialog from './components/ApprovalHistoryDialog';
import { useGetApprovalLimitGroupByIdQuery } from '../../../../api/endpoints/approvalLimitGroups';
import useApprovalGroups from './hooks/useApprovalGroups';
import { useLanguage } from '../../../../contexts/LanguageContext';

const ApprovalGroupsPage = () => {
    const { th } = useLanguage();

    const {
        toast,
        tableProps,
        formProps,
        dialogVisible,
        historyDialogVisible,
        setHistoryDialogVisible,
        historySelectedItem,
        filterFields,
        customFilterTypes,
        customFilterOptions,
        handleSearch,
        handleResetFilters,
        handleApplyFilters,
        setDialogVisible,
        openNewDialog
    } = useApprovalGroups();

    const handleDialogHide = () => {
        setDialogVisible(false);
    };

    const handleHistoryDialogHide = () => {
        setHistoryDialogVisible(false);
    };

    const columnsRef = useRef(null);

    return (
        <div className="card">
            <Toast ref={toast} />

            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('menu.approvalGroups')} </h1>
                <Button label={th('approvalGroups.newGroup')} icon="pi pi-plus" onClick={openNewDialog} />
            </div>

            <ApprovalGroupsFilter
                filterFields={filterFields}
                columns={columnsRef.current}
                customFilterTypes={customFilterTypes}
                customFilterOptions={customFilterOptions}
                handleSearch={handleSearch}
                handleApplyFilters={handleApplyFilters}
                handleResetFilters={handleResetFilters}
            />

            <ApprovalGroupsForm {...formProps} visible={dialogVisible} onHide={handleDialogHide} />

            <ApprovalHistoryDialog visible={historyDialogVisible} onHide={handleHistoryDialogHide} selectedItem={historySelectedItem} useGetByIdQuery={useGetApprovalLimitGroupByIdQuery} />

            <ApprovalGroupsTable {...tableProps} />
        </div>
    );
};

export default ApprovalGroupsPage;
